
//
// Admin Page Controller
//

module.exports = function AdminController ($page, $$) {

  // Dom
  var $hideButtons = $$('[data-toggle-hidden-rows]');
  var $main        = $$('main');

  // Widgets
  var tableRows = $$('[data-widget="live-table-row"]').toArray().map(getWidgetAt);


  // Ajax Stuff

  function dispatchUpdate (type, date, key, value, success) {
    $.ajax('/admin/ajax.php', {
      type: "post",
      dataType: 'json',
      data: {
        type:  type,
        date:  date,
        key:   key,
        value: value,
      },
      success: function (res) {
        log(res);
        if (res.success) {
          success(res.result);
        } else {
          displayError(type, date, key, value, res.reason);
          console.error(res);
        }
      },
      error: function (err) {
        //displayError(type, date, key, value, err);
        console.error(arguments);
      }
    });
  }

  function displayError (type, date, key, value, errorText) {
    alert("Couldn't save this row: [" + [ type, date, key, value ].join(":") + "].\n"
        + "The error was: \"" + errorText + "\".\n"
        + "Copy this textbox and send it to Jordan.");
  }


  // Functions

  function onRowChange (row) {
    return function _onRowChange (type, date, key, value) {
      dispatchUpdate(type, date, key, value, function (rowData) { row.showSuccess(key, value, rowData) });
    }
  }


  // Widget wiring

  tableRows.forEach((row) => row.onUpdate(onRowChange(row)));


  // Listeners

  $hideButtons.on('click', function () {
    var $this = $(this);

    if ($this.hasClass('pressed')) {
      $hideButtons.removeClass('pressed');
      $hideButtons.text('Show hidden rows');
      $main.addClass('hide-completed-rows');
    } else {
      $hideButtons.addClass('pressed');
      $hideButtons.text('Hide hidden rows');
      $main.removeClass('hide-completed-rows');
    }
  });


  // Highlight linked row

  if (window.location.hash) {
    var target = window.location.hash.replace('#', '');

    tableRows.forEach(function (row) {
      row.highlightIfMatching(target);
    });
  }


  // Debug

  //dispatchUpdate('commission_requests', 1597115879, 'status', 'started', function () {
  //  tableRows[tableRows.length - 1].showSuccess('status', 'started');
  //});

}

